import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  Optional,
  QueryList,
  Self,
  ViewChildren,
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { CheckboxItem } from '@shared/models/step.model';
import { PlIcon } from '@src/app/icon-library/icons';

@Component({
  selector: 'pl-checkbox-item',
  templateUrl: './checkboxItem.component.html',
  styleUrls: ['./checkboxItem.component.scss'],
})
export class CheckboxItemComponent implements ControlValueAccessor {
  @Input({ required: true }) public isLast: boolean = false;
  @Input({ required: true }) public isDisabled: boolean = false;

  public item: CheckboxItem | null = null;

  private onChangeCallback!: (value: CheckboxItem) => void;
  private onTouchedCallback!: () => void;

  public readonly PlIcon: typeof PlIcon = PlIcon;

  @HostBinding('tabindex') public tabindex: number = 1;
  @HostListener('focus') public onFocus(): void {
    if (this.customCheckBox && this.customCheckBox.length > 0) {
      // preventScroll: true because scroll is handled by directive plScrollToInvalidControlOnSubmit
      this.customCheckBox.first.nativeElement.focus({ preventScroll: true });
    }
  }

  @ViewChildren('customCheckBox', { read: ElementRef }) public customCheckBox!: QueryList<ElementRef>;

  constructor(@Optional() @Self() public controlDir: NgControl) {
    if (this.controlDir) {
      this.controlDir.valueAccessor = this;
    }
  }

  public registerOnChange(fn: (value: CheckboxItem) => void): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouchedCallback = fn;
  }

  public writeValue(itemToWrite: CheckboxItem | null): void {
    if (itemToWrite !== undefined && itemToWrite !== null) {
      this.item = itemToWrite;
    }
  }

  public onTouched(): void {
    if (this.onTouchedCallback) {
      this.onTouchedCallback();
    }
  }

  public onCheckboxToggle(): void {
    this.emitChanges();
  }

  private emitChanges(): void {
    if (this.item) {
      this.onChangeCallback(this.item);
      this.onTouched();
    }
  }

  public onKeyDownOnCheckmark(event: KeyboardEvent, item: CheckboxItem): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      item.checked = !item.checked;
      this.onCheckboxToggle();
    }
  }
}
